(function () {
  'use strict';
  var T = window.TENZ || {};
  var routes = T.routes || { cartAdd: '/cart/add.js', cart: '/cart.js', cartUrl: '/cart' };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    function fmt(num, decimals, thousands, dec) {
      num = (num / 100).toFixed(decimals);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + dec + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.querySelector('[data-toast-text]').textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function updateCartCount() {
    return fetch(routes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (AJAX with native fallback) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[data-submit]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    if (btn) btn.classList.add('is-loading');

    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.data.description || res.data.message || 'This item could not be added. Please try again.';
          if (err) { err.textContent = msg; err.hidden = false; } else { toast(msg); }
          return;
        }
        toast((res.data.product_title || 'Item') + ' added to cart');
        return updateCartCount();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input[type="number"]');
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
    input.value = v;
  });

  /* ---------- Gallery ---------- */
  function showMedia(scope, mediaId, src) {
    var main = scope.querySelector('.gallery__img');
    if (main && src) { main.removeAttribute('srcset'); main.src = src; }
    scope.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId));
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var scope = t.closest('[data-gallery]');
    showMedia(scope, t.getAttribute('data-media-id'), t.getAttribute('data-src'));
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var jsonEl = wrap.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var selects = wrap.querySelectorAll('[data-option-index]');
    if (!selects.length) return;
    var idInput = wrap.querySelector('[data-variant-id]');
    var btn = wrap.querySelector('[data-submit]');
    var btnText = wrap.querySelector('[data-submit-text]');
    var priceEl = wrap.querySelector('[data-price]');
    var compareEl = wrap.querySelector('[data-compare]');
    var priceWrap = wrap.querySelector('[data-price-wrap]');
    var scope = wrap.closest('[data-product-scope]');
    var updateUrl = wrap.getAttribute('data-update-url') === 'true';

    function onChange() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!variant) {
        btn.disabled = true;
        btnText.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      btn.disabled = !variant.available;
      btnText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.hidden = !onSale;
      compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      priceWrap.classList.toggle('price--sale', !!onSale);
      if (scope && variant.featured_media) {
        var thumb = scope.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
        showMedia(scope, variant.featured_media.id, thumb ? thumb.getAttribute('data-src') : null);
      }
      if (updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', onChange); });
  });

  /* ---------- Collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Mobile menu ---------- */
  var menu = document.querySelector('[data-menu]');
  var openBtn = document.querySelector('[data-menu-open]');
  function setMenu(open) {
    if (!menu) return;
    menu.hidden = !open;
    document.body.classList.toggle('menu-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var c = menu.querySelector('[data-menu-close]'); if (c) c.focus(); }
    else if (openBtn) openBtn.focus();
  }
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-menu-close]')) setMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu && !menu.hidden) setMenu(false); });
})();
